import { createContext } from 'react'

export const RadioGroupContext = createContext(null)
